import React from 'react';
import { PrismicRichText } from "@prismicio/react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { colorCheck } from "../../utils/accessibility-helpers";
import { Link } from "gatsby";
import ScriptInjector from "../script-injector";
import Calculator from "../calculator";

export const ContentTabs = (props) => {

    const sc = props.slice.primary;

    const quotes = props.slice.items;

    let space = sc.spacing;

    if (space === "Both large") {
        space = "gutter";
    } else if (space === "Both small") {
        space = "gutter sm";
    } else if (space === "Top large") {
        space = "gutter bot";
    } else if (space === "Top small") {
        space = "gutter bot sm";
    } else if (space === "Bottom large") {
        space = "gutter top";
    } else {
        space = "gutter top sm";
    }

    let bg = sc.background === "gradient" ? "gradient-to-b from-grey-light/60 to-white" : sc.background;

    

    return (
        <section className={"tabz relative bg-" + (bg)}>
            <div className={"wrapper " + (space)}>
            {sc.section_title ? <div className="md:text-center md:w-3/4 md:m-auto !mb-4"><PrismicRichText field={sc.section_title.richText} /></div> : ''}
            {sc.section_content ? <div className="md:text-center md:w-3/4 md:m-auto"><PrismicRichText field={sc.section_content.richText} /></div> : ''}
            <Tabs className="mt-10">
                <TabList>
                    {quotes.map((tab, index) => {
                        return <Tab key={index} className={"tabby flex items-center gap-2 icon " + tab.theme}>
                        {tab.tab_label_icon.url != null ? <img className="w-6" src={tab.tab_label_icon.url} alt="" /> : ''}
                        {tab.tab_label}</Tab>
                    })}
                </TabList>
                
                {quotes.map((tab, index) => {
                    let layout = tab.layout === "Left" ? "md:flex-row" : "md:flex-row-reverse"
                    return (
                        
                        <TabPanel key={index}>
                            <div className={"flex flex-col justify-between items-center gap-6 md:gap-24 article " + (layout) + ' ' + (tab.theme)}>
                                
                                <div className={"t-1 w-full md:w-2/4 " + (tab.theme)}>
                                    <div className={"label bg-opacity-10 font-bold uppercase tracking-widest text-xs mb-1 md:mb-2 text-" + colorCheck(tab.theme)}>{tab.tab_label}</div>
                                    <div className="text-grey"><PrismicRichText field={tab.tab_title.richText} /></div>
                                    <PrismicRichText field={tab.tab_content.richText} />
                                    <ScriptInjector html={tab.custom_html} />
                                    <div className="mt-8">
                                    {tab.button_link?.url ? (
                                        <Link to={tab.button_link.url}>
                                            <div className="btn bg-yellow">
                                                {tab.button_label}
                                            </div>
                                        </Link>
                                    ) : ''}
                                    </div>
                                </div>
                                <div className="t-2 w-full md:w-2/4 support-media">
                                    {tab.supporting_content === "Custom" ? (
                                        <div dangerouslySetInnerHTML={{ __html: tab.custom }} />
                                    ) : tab.supporting_content === "Pharmacy" ? (
                                        <Calculator 
                                            className="quote-slider"
                                            buttonText={sc.text || "Get Quote"}
                                            formId="43f5c55e-f8d5-4ba4-8cec-d7a4b90f68c1"
                                        />
                                    ) : (tab.supporting_content === "Media" || tab.supporting_content === null || !tab.supporting_content) ? (
                                        tab.support_media == "Animation" ? (
                                            <>
                                            <video className="min-h-[600px] hidden md:block" autoPlay="autoplay" muted onContextMenu="return false;" preload="auto">
                                                <source src={tab.video_animation.url} />
                                            </video>
                                            <div className="block md:hidden"><GatsbyImage image={getImage(tab.tab_image)} alt={tab.tab_image.alt} />
                                            </div>
                                            </>
                                        ) : <GatsbyImage image={getImage(tab.tab_image)} className="rounded-3xl" />
                                    ) : <GatsbyImage image={getImage(tab.tab_image)} className="rounded-3xl" /> }
                                </div>
                            </div>
                        </TabPanel>
                        
                    )
                })}
                
            </Tabs>
            </div>
        </section>
    );
}

